import AbstractFormulaNode from "./AbstractFormulaNode.js";

/**
 * `constantFormulaNode` is a concrete implementation of `abstractFormulaNode`
 * representing a constant value.
 *
 * @param {string} spec.value - Value
 */
export default class ConstantFormulaNode extends AbstractFormulaNode {
	constructor(spec) {
		super(spec);

		this._value = spec.value;
		this._type = spec.type;
	}

	getValue() {
		return this._value;
	}

	getType() {
		return this._type;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitConstantNode(this, additionalInformation);
	}

	isLeaf() {
		return true;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.value = this._value;
		properties.valueType = this._type;

		return properties;
	}

	static getType() {
		return "ConstantNode";
	}

	static transformMaterializationData(data) {
		super.transformMaterializationData(...arguments);

		data.type = data.valueType;
	}
}
